import { useParams } from 'react-router-dom'

const byObject = {
  person: ({ id }) => `/borrowers/${id}`,
}

const byPrefix = {
  BO: ({ id }) => `/borrowers/${id}`,
  UR: ({ id }) => `/employees/${id}`,
  TD: ({ id }) => `/templates/${id}`,
  TM: ({ id }) => `teams/${id}`,
  RL: ({ id }) => `roles/${id}`,
}

const getLink = (item) => {
  const { id, object } = item || {}

  const prefix = id?.slice(0, 2)

  const fn = byObject[object] || byPrefix[prefix]

  if (fn) return fn(item)

  return ''
}

const useLink = (item, options = {}) => {
  const params = useParams()

  return getLink({ ...params, ...item, ...options })
}

export { useLink }

export default getLink
